import { Injectable, Signal, signal } from '@angular/core';
import { IntroductionModel } from '../models/introduction.model';

@Injectable({ providedIn: 'root' })
export class IntroductionService {
    public readonly _model = signal<IntroductionModel | undefined>(undefined);

    public setModel(model: IntroductionModel): void {
        this._model.set(model);
    }

    public updateModel(model: Partial<IntroductionModel>): void {
        this._model.set({ ...model, ...this._model() });
    }

    public getModel(): Signal<IntroductionModel | undefined> {
        return this._model;
    }
}
